import { justNumbers } from "./justnumbers";

export function formatPhone(ph:string){
  const phone=justNumbers(ph);
  if(!phone)return '';
  if(phone.length==1){
    return `(${phone}`;
  }
  if(phone.length==2){
     return `(${phone}`;
  }
  if(phone.length<=6){
     return `(${phone.substring(0,2)}) ${phone.substring(2)}`;
  }
  if(phone.length<=10){
     return `(${phone.substring(0,2)}) ${phone.substring(2,6)}-${phone.substring(6)}`;
  }
  return `(${phone.substring(0,2)}) ${phone.substring(2,3)} ${phone.substring(3,7)}-${phone.substring(7)}`;
}

/**
 * ÚNICA função de telefone BR do front (espelha `buildPhoneVariants` do backend).
 * Devolve [13 dígitos (55+DDD+9+número, canônico), 12 dígitos (sem o 9)] ou null se não for
 * celular BR reconhecível. Aceita 10 a 13 dígitos, com ou sem 55 e com máscara.
 */
export function buildPhoneVariants(phone:string):[string,string]|null{
  let digits=justNumbers(phone||'');
  if(digits.length===12||digits.length===13){
    if(digits.slice(0,2)!=='55')return null;
    digits=digits.slice(2);
  }
  if(digits.length===10){
    if(!/^[6-9]/.test(digits.slice(2)))return null;
    digits=digits.slice(0,2)+'9'+digits.slice(2);
  }
  if(digits.length!==11||digits[2]!=='9'||digits[0]==='0')return null;
  return ['55'+digits,'55'+digits.slice(0,2)+digits.slice(3)];
}

/** Telefone para exibir/enviar: DDD + 9 + número (11 dígitos), igual com ou sem o 9 na origem. */
export function normalizePhone(ph?:string){
   if(!ph)
      return '';
   const variants=buildPhoneVariants(ph);
   if(variants)return variants[0].slice(2);
   return justNumbers(ph);
}

/**
 * Compara dois identificadores de cliente como "iguais", tolerando o 9º dígito
 * (ex.: `5549998144777` == `554998144777`). Para wa_id que não é telefone, cai
 * no comparativo direto de dígitos.
 */
export function phoneEquals(a?:string|null,b?:string|null):boolean{
  if(!a||!b)return false;
  const na=justNumbers(a);
  const nb=justNumbers(b);
  if(!na||!nb)return false;
  if(na===nb)return true;
  const va=buildPhoneVariants(na);
  const vb=buildPhoneVariants(nb);
  if(!va||!vb)return false;
  return va[0]===vb[0];
}